<div id="main-content" *ngIf="locationConfirmationData ; else loading" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <h1 class="bofa--heading is-4 double-bottom-space">Location Confirmation</h1>

  <div>
    <mat-card  appearance="outlined"  class="af-mat-card mat-elevation-z flex-change double-bottom-space flex-50">
      
      <h2 class="bofa--heading is-4 double-bottom-space margin-l">Current Address</h2>
      <mat-card-content>
        <p class="bofa--heading is-8 has-no-margin group addBlock margin-l-25" >
          <span class="itemAdd">{{ locationConfirmationData.currentAddress.streetAddress1 }}</span>
          <span class="itemAdd" *ngIf="locationConfirmationData.currentAddress.streetAddress2"> {{ locationConfirmationData.currentAddress.streetAddress2 }}</span>
          <span class="itemAdd" *ngIf="locationConfirmationData.currentAddress.streetAddress3"> {{ locationConfirmationData.currentAddress.streetAddress3 }}</span>
            <span class="itemAdd">{{ locationConfirmationData.currentAddress.city }}</span>
              <span class="itemAdd" *ngIf="locationConfirmationData.currentAddress.usState">{{ stateText }}</span>
                <span class="itemAdd" *ngIf="locationConfirmationData.currentAddress.state">{{ locationConfirmationData.currentAddress.state }}</span>
                  <span class="itemAdd">{{ locationConfirmationData.currentAddress.zipCode }}</span>
                    <span class="itemAdd">{{ locationConfirmationData.currentAddress.countryValue }}</span> </p>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="max-width max-zoom bottom-space" id="locationConfirmDesc"><abbr title="required">* </abbr>When it’s time to schedule your fingerprinting and/or
    Form I-9 Section 2 appointment, our scheduling system will provide you with a list of locations in the proximity
    of your address above. Is this the address where you will be located
    at the time of your fingerprinting/I-9 appointment? </div>

  <form [formGroup]="coreSiteGroup">
    <div class="bottom-space max-width">
      <mat-radio-group class="minor-radio-padding" required aria-describedby="locationConfirmDesc"
        formControlName="usingCurrentAddress">
        <mat-radio-button class="minor-list-space radio-padding" matInput value="1">Yes</mat-radio-button>
        <mat-radio-button class="minor-radio-padding" matInput value="0">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <mat-error *ngIf="submit.value && usingCurrentAddress.hasError('required')">Please select if using
      current address</mat-error>

    <div *ngIf="usingCurrentAddress.value === '0'" class="bottom-space">
      <p class="bofa--heading is-6 global-red">Please enter the address where you will be located at the time of
        your fingerprinting/I-9 appointment.</p>
      <mat-expansion-panel [class.border]="border" [expanded]="true" [hideToggle]="true"
        class="af-mat-card mat-elevation-z panel-width">
        <mat-expansion-panel-header class="mat-expansion outlined background-color" >
          <mat-panel-title>
            Address
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field class="max-zoom field-space padding-top width-350" >
          <mat-label>Street address</mat-label>
          <input matInput formControlName="streetAddress1" maxlength="600">
          <mat-error>Please enter a valid address</mat-error>
        </mat-form-field>

        <div class="non-required">
          <mat-form-field class="max-width">
            <mat-label>More street address (if applicable)</mat-label>
            <input matInput formControlName="streetAddress2" maxlength="255">
            <mat-error>Please enter a valid address</mat-error>
          </mat-form-field>
        </div>

        <div class="non-required">
          <mat-form-field class="max-width">
            <mat-label>More street address (if applicable)</mat-label>
            <input matInput formControlName="streetAddress3" maxlength="255">
            <mat-error>Please enter a valid address</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="max-zoom field-space width-350">
          <mat-label>City/Town/Province</mat-label>
          <input matInput formControlName="city" maxlength="200">
          <mat-error>Please enter a valid city/town/province</mat-error>
        </mat-form-field>

        <mat-form-field class="max-zoom field-space width-350"  hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Country</mat-label>
          <mat-select formControlName="country" required>
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let country of locationConfirmationData.countryLookup | keyvalue : valueAscOrder"
              [value]="country.key">
              {{country.value}}
            </mat-option>
          </mat-select>
          <mat-hint class="bofa--skiplink">
            <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
            {{ dropDownScreenReaderCountry(country) }}
          </mat-hint>
          <mat-error *ngIf="country.hasError('required') ">Please select Country
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="country.value == 186" class="max-zoom field-space width-350" >
          <mat-label>State</mat-label>
          <mat-select formControlName="usState">
            <mat-option>Select</mat-option>
            <mat-option *ngFor="let us of locationConfirmationData.usStateLookup | keyvalue : valueAscOrder"
              [value]=us.key>
              {{us.value}}
            </mat-option>
          </mat-select>
          <mat-hint class="bofa--skiplink">
            <!-- Hidden for screen readers so it reads the current value selected from the dropdown -->
            {{ dropDownScreenReaderState(usState) }}
          </mat-hint>
        </mat-form-field>

        <div *ngIf="country.value !=186" class="non-required">
          <mat-form-field class="max-width" >
            <mat-label>State</mat-label>
            <input matInput formControlName="state" maxlength="100">
            <mat-error>Please enter a valid state</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="max-zoom field-space width-350" >
          <mat-label> County </mat-label>
          <mat-hint>Enter 'N/A' if not applicable</mat-hint>
          <input matInput formControlName="county" maxlength="100">
          <mat-error>Please enter a valid county</mat-error>
        </mat-form-field>

        <mat-form-field class="max-zoom field-space width-350"  hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Zip code/Postal code</mat-label>
          <input matInput formControlName="zipCode" maxlength="60" required>
          <mat-error>Please enter valid zip code/postal code</mat-error>
        </mat-form-field>
      </mat-expansion-panel>
    </div>

    <div class="padding-top" *ngIf="usingCurrentAddress.value == 1 || (usingCurrentAddress.value == 0 && !zipCode.hasError('required') && !country.hasError('required'))">
      <mat-checkbox formControlName="addressConfirmed" class="minor-check-padding" aria-required="true" required (focusout)="confirmOnBlur()" (focusin)="confirmOnFocus()">
        <mat-label><abbr title="required">* </abbr><span class="white-space" >Address Confirmed</span>
        </mat-label>
      </mat-checkbox>
      <mat-error class="margint-t" *ngIf="addressConfirmed.hasError('invalid') && check"> Please check Address Confirmed </mat-error>

      <div *ngIf="addressConfirmed.value">
        <p role="alert" aria-live="polite">Thank you for confirming your location for the fingerprinting and/or Form I-9 Section 2 appointment.
          After you complete this consent form you will receive an email with next steps for scheduling your
          appointment</p>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading Location Confirmation...
</ng-template>
